import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Colors from "../styles/Colors";
import Header from "./Header";
import { useQuery } from "../hooks";
import SetReferralCodeModal from "./SetReferralCodeModal";
// import Footer from "./Footer";

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);

  let query = useQuery();

  const referralCode = query.get("code");

  useEffect(() => {
    if (referralCode) {
      setModalIsOpen(true);
    }
  }, [referralCode]);

  return (
    <Container>
      <Header />
      <MainContainer>
        {/* <BetaContainer>
          <BetaText>
            Unibot is still under beta testing. Please use at your own risk.
          </BetaText>
        </BetaContainer> */}
        {children}
      </MainContainer>
      {referralCode && (
        <SetReferralCodeModal
          isShowModal={modalIsOpen}
          setShowModal={setModalIsOpen}
          code={referralCode}
        />
      )}

      {/* <Footer /> */}
    </Container>
  );
};

export default Layout;

const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: ${Colors.backgroundGray3};
`;

const MainContainer = styled.div`
  width: 100%;
  padding-top: 70px;
  background-color: ${Colors.backgroundGray3};
  min-height: calc(100vh - 70px);
  display: flex;
  flex-direction: column;
`;

const BetaContainer = styled.div`
  text-align: center;
  background-color: #4d3c41;
  height: 30px;
  /* border-bottom: 6px solid rgba(0, 0, 0, 0.3); */
`;

const BetaText = styled.span`
  color: ${Colors.gray2};
  font-size: 13px;
  line-height: 22px;
  @media (max-width: 1200px) {
    font-size: 12px;
    line-height: 16px;
  }
`;
